import { render, staticRenderFns } from "./Formula.vue?vue&type=template&id=f7c9eb9c&scoped=true"
import script from "./Formula.vue?vue&type=script&lang=js"
export * from "./Formula.vue?vue&type=script&lang=js"
import style0 from "./Formula.vue?vue&type=style&index=0&id=f7c9eb9c&prod&lang=scss&scoped=true"
import style1 from "./Formula.vue?vue&type=style&index=1&id=f7c9eb9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c9eb9c",
  null
  
)

export default component.exports